import OverviewComponent from '../OverviewComponent.vue'

export default [
    {
        path: '/managers-hub',
        name: 'ManagersHub',
        meta: { layout: 'default' },
        component: OverviewComponent,
    },
    // Legacy redirect so old bookmarks/links keep working
    {
        path: '/overview',
        redirect: '/managers-hub',
    },
]